import React from 'react';
import { ArrowRightIcon } from '@radix-ui/react-icons';
import { cn } from '../../lib/utils';

export function BentoGrid({ children, className, ...props }) {
  return (
    <div
      className={cn(
        'grid w-full auto-rows-[16rem] grid-cols-1 md:grid-cols-3 gap-4',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function BentoCard({
  name,
  className,
  background,
  Icon,
  description,
  href,
  onClick,
  cta = 'Learn more',
  ...props
}) {
  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    } else if (href) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div
      key={name}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(e); }}
      className={cn(
        'group relative col-span-3 flex flex-col justify-between overflow-hidden rounded-2xl p-6 cursor-pointer',
        'bg-white border border-slate-200 text-slate-900 shadow-sm transition-all duration-300 hover:border-amber-400 hover:shadow-md hover:scale-[1.01]',
        'dark:bg-slate-900 dark:border-slate-800 dark:text-slate-100 transform-gpu dark:shadow-none dark:hover:border-amber-400/50',
        className
      )}
      {...props}
    >
      {background}
      
      <div className="z-10 flex flex-col justify-between h-full pointer-events-none">
        <div className="flex transform-gpu flex-col gap-2 transition-all duration-300 lg:group-hover:-translate-y-1">
          {Icon && <Icon className="h-10 w-10 origin-left transform-gpu text-amber-500 transition-all duration-300 ease-in-out group-hover:scale-90" />}
          <h3 className="text-xl font-bold text-slate-900 dark:text-white">
            {name}
          </h3>
          <p className="max-w-lg text-sm text-slate-600 dark:text-slate-300 leading-relaxed">{description}</p>
        </div>

        <div className="pt-4">
          <span className="inline-flex items-center gap-1 text-xs font-bold text-amber-600 dark:text-amber-400 group-hover:text-amber-500 transition">
            {cta}
            <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
          </span>
        </div>
      </div>

      <div className="pointer-events-none absolute inset-0 transform-gpu transition-all duration-300 group-hover:bg-slate-950/5 dark:group-hover:bg-slate-800/10" />
    </div>
  );
}
